import { ref } from 'vue';

let sdkLoadingPromise = null; // module is singleton, so this variable cached
const isSdkReady = ref(false);  // script ready state
const sdkError   = ref(null);   // реактивная ошибка, если понадобится

export function useCloverSDK() {
  if (!sdkLoadingPromise) {
    sdkLoadingPromise = new Promise((resolve, reject) => {
      // if Clover obj already exists - do nothing
      if (window['Clover']) {
        isSdkReady.value = true;
        return resolve();
      }

      if (!window['_EZCL']?.sdkUrl) {
        sdkError.value = new Error('🍀 sdk.js: application settings not detected');
        reject(sdkError.value);
      }

      const s = document.createElement('script');
      s.src   = window['_EZCL']?.sdkUrl;
      s.async = true;

      s.onload = () => {
        isSdkReady.value = true;
        console.log('🍀 sdk.js: payments is ready');
        resolve();
    };
    s.onerror = () => {
        sdkError.value = new Error('🍀 sdk.js: loading failed');
        reject(sdkError.value);
      };

      document.head.appendChild(s);
    });
  }

  return { isSdkReady, sdkError, sdkLoadingPromise };
}